import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../api/authApi';

// ==================== ASYNC THUNKS ====================

// ✅ POST - Filter Food Schedule
export const filterFoodScheduleAsync = createAsyncThunk(
  'foodFilter/filterFoodSchedule',
  async (filters, { rejectWithValue }) => {
    try {
      console.log('🔄 POST - Filtering food schedule with:', filters);
      const response = await apiService.filterFoodSchedule(filters);
      console.log('✅ POST - Filtered food schedule:', response);
      
      if (response?.status === true && response?.data) {
        return response;
      } else {
        console.warn('⚠️ POST - API returned status false or no data');
        return { data: [] };
      }
    } catch (error) {
      console.error('❌ POST - Filter food schedule error:', error);
      return rejectWithValue(error.message || 'Failed to filter food schedule');
    }
  }
);

// ✅ GET - Filter by Available Time
export const getFilterByAvailableTimeAsync = createAsyncThunk(
  'foodFilter/getFilterByAvailableTime',
  async (availableTime, { rejectWithValue }) => {
    try {
      console.log('🔄 GET - Fetching filter by available time:', availableTime);
      const response = await apiService.getFilterByAvailableTime(availableTime);
      console.log('✅ GET - Filter by available time response:', response);
      
      if (response?.status === true && response?.data) {
        return response;
      } else {
        console.warn('⚠️ GET - API returned status false or no data for available time:', availableTime);
        return { data: [] };
      }
    } catch (error) {
      console.error('❌ GET - Get filter by available time error:', error);
      return rejectWithValue(error.message || 'Failed to fetch filter by available time');
    }
  }
);

// ==================== INITIAL STATE ====================

const initialState = {
  menu: [],
  filteredMenu: [],
  isLoading: false,
  error: null,
  lastFetched: null,
  currentDay: 'Monday',
  currentMealType: null,
  currentAvailableTime: null,
};

// ==================== SLICE ====================

const foodFilterSlice = createSlice({
  name: 'foodFilter',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearFilters: (state) => {
      state.currentDay = 'Monday';
      state.currentMealType = null;
      state.currentAvailableTime = null;
      state.filteredMenu = [];
    },
    setDay: (state, action) => {
      state.currentDay = action.payload;
    },
    setMealType: (state, action) => {
      state.currentMealType = action.payload;
    },
    setAvailableTime: (state, action) => {
      state.currentAvailableTime = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // ===== POST - FILTER FOOD SCHEDULE =====
      .addCase(filterFoodScheduleAsync.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(filterFoodScheduleAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        let data = action.payload?.data || [];
        if (!Array.isArray(data)) {
          data = [];
        }
        state.filteredMenu = data;
        state.menu = data;
        state.lastFetched = new Date().toISOString();
        state.error = null;
        console.log(`✅ POST - Loaded ${data.length} filtered food items`);
      })
      .addCase(filterFoodScheduleAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to filter food schedule';
        state.filteredMenu = [];
      })
      
      // ===== GET - FILTER BY AVAILABLE TIME =====
      .addCase(getFilterByAvailableTimeAsync.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFilterByAvailableTimeAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        let data = action.payload?.data || [];
        if (!Array.isArray(data)) {
          data = [];
        }
        state.filteredMenu = data;
        state.menu = data;
        state.lastFetched = new Date().toISOString();
        state.error = null;
        console.log(`✅ GET - Loaded ${data.length} items for available time: ${state.currentAvailableTime}`);
      })
      .addCase(getFilterByAvailableTimeAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch filter by available time';
        state.filteredMenu = [];
      });
  },
});

// ==================== EXPORT ACTIONS & REDUCER ====================

export const {
  clearError,
  clearFilters,
  setDay,
  setMealType,
  setAvailableTime,
} = foodFilterSlice.actions;

export default foodFilterSlice.reducer;